import React from "react";
import {
  Select,
  InputLabel,
  MenuItem,
  FormControl,
  FormGroup,
  FormLabel,
  FormControlLabel,
  TextField,
  Checkbox
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DatePicker from "../../DatePicker/DatePicker";

import { SpeciesChooser } from "../components/SpeciesChooser";
import { GenderChooser } from "../components/GenderChooser";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: "100%",
  },
  formControlDatePicker: {
    margin: "0.5rem 0 0 0.5rem",
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  preconditions: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "90%",
    margin: "0 auto",
    alignItems: "flex-end"
  },
  preconditionsLabel: {
    width: "90%",
    margin: "0 auto",
  },
  otherSelects: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
  },
}));

const AnimalInfo = ({
  animalinfo,
  preconditions,
  handleDateChange,
  handleInputChangeInfo,
  handlePreconditions,
  handleSpeciesChange,
  handleGenderChange,
}) => {
  const classes = useStyles();

  return (
    <div className="formStep--wrapper animalInfo">
      <h1>Wichtige Angaben zu Deinem Tier</h1>

      <div className="animalinfo--grid">
      <div className="animalinfo__species">
          <SpeciesChooser species={animalinfo.species} handleSpeciesChange={handleSpeciesChange} />
        </div>
        <div className="animalinfo__gender">
          <GenderChooser species={animalinfo.sex} handleGenderChange={handleGenderChange} />
        </div>

        <FormControl variant="outlined" className={classes.formControl}>
          <TextField
            className="name"
            id="animalname"
            label="Name Deines Tiers"
            name="animalname"
            variant="outlined"
            value={animalinfo.animalname}
            onChange={handleInputChangeInfo}
          />
        </FormControl>

        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="age-label">Alter</InputLabel>
          <Select
            name="age"
            labelId="age-label"
            id="age"
            className="select"
            value={animalinfo.age}
            onChange={handleInputChangeInfo}
            label="Alter"
          >
            <MenuItem value="Unter 1 Jahr">Unter 1 Jahr</MenuItem>
            <MenuItem value="1 bis 5 Jahre">1 bis 5 Jahre</MenuItem>
            <MenuItem value="5 bis 10 Jahre">5 bis 10 Jahre</MenuItem>
            <MenuItem value="über 10 Jahre">über 10 Jahre</MenuItem>
          </Select>
        </FormControl>
        <FormControl variant="outlined" className={classes.formControl}>
          <TextField
            className="weight"
            id="weight"
            label="Gewicht (Kg)"
            name="weight"
            variant="outlined"
            value={animalinfo.weight || ""}
            onChange={handleInputChangeInfo}
          />
        </FormControl>

        <FormControl variant="outlined" className={`${classes.formControl} castrated`}>
          <FormGroup className={classes.castrated}>
            <InputLabel id="species-label">Kastriert</InputLabel>
            <Select
              name="castrated"
              labelId="castrated-label"
              id="castrated"
              className="select"
              value={animalinfo.castrated}
              onChange={handleInputChangeInfo}
              label="Kastriert"
            >
              <MenuItem value={true}>Ja</MenuItem>
              <MenuItem value={false}>Nein</MenuItem>
            </Select>
          </FormGroup>
        </FormControl>

        <div className="femaleChoiceGrid">
          {animalinfo.species === "dog" && animalinfo.sex === "female" && !animalinfo.castrated && (
            <FormControl className={`${classes.formControlDatePicker} lastHeat`}>
              <DatePicker
                setSelectedDate={(event) => {
                  handleDateChange(event, "lastHeat");
                }}
                selectedDate={animalinfo.lastHeat}
                datePickerId={"lastHeatDatePicker"}
                id="lastHeatDatePicker"
                classes={{ label: classes.label }}
                label={"Letzte Läufigkeit"}
              />
            </FormControl>
          )}

          {animalinfo.species === "cat" && (
            <FormControl className={`${classes.formControl} otherSelectsa`}>
              <FormGroup className={classes.otherSelects}></FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={animalinfo.free}
                    onChange={handleInputChangeInfo}
                    name="free"
                  />
                }
                label="Freigänger"
              />
            </FormControl>
          )}

          <FormControl className={`${classes.formControl} otherSelects`}>
            <FormGroup className={classes.otherSelects}>
              {animalinfo.sex === "female" && !animalinfo.castrated ? (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={animalinfo.givingBirth}
                      onChange={handleInputChangeInfo}
                      name="givingBirth"
                    />
                  }
                  label="In der Geburt"
                />
              ) : null}
              {animalinfo.sex === "female" && !animalinfo.castrated && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={animalinfo.pregnant}
                      onChange={handleInputChangeInfo}
                      name="pregnant"
                    />
                  }
                  label="Trächtig"
                />
              )}
            </FormGroup>
          </FormControl>
        </div>
      </div>

      <FormControl component="fieldset" className={`${classes.formControl} preconditions`}>
        <FormLabel component="legend" className={classes.preconditionsLabel}>
          Bekannte schwere Vorerkrankung
        </FormLabel>
        <FormGroup className={classes.preconditions}>
          <FormControlLabel
            control={
              <Checkbox checked={preconditions.heart} onChange={handlePreconditions} name="heart" />
            }
            label="Herz"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={preconditions.kidney}
                onChange={handlePreconditions}
                name="kidney"
              />
            }
            label="Niere"
          />
          <FormControlLabel
            control={
              <Checkbox checked={preconditions.liver} onChange={handlePreconditions} name="liver" />
            }
            label="Leber"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={preconditions.epilepsia}
                onChange={handlePreconditions}
                name="epilepsia"
              />
            }
            label="Epilepsie"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={preconditions.cancer}
                onChange={handlePreconditions}
                name="cancer"
              />
            }
            label="Krebserkrankung"
          />
          <FormControlLabel
            className={`${classes.formControl} lastHeat`}
            control={
              <TextField
                id="other"
                value={preconditions.other}
                onChange={handlePreconditions}
                name="other"
                label="Sonstige Erkrankungen"
              />
            }
          />
        </FormGroup>
      </FormControl>
    </div>
  );
};

export default AnimalInfo;
